import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-splash-screen',
  standalone: false,
  templateUrl: './splash-screen.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnInit {
  @Output() splashComplete = new EventEmitter<void>();
  @Input() isLoadingData = false;
  @Input() loadingProgress = 0;
  
  showTitle = false;
  showSubtitle = false;
  showLoading = false;
  isClosing = false;
  wasSkipped = false;
  showSkippedLoading = false;
  
  ngOnInit() {
    this.startSplashSequence();
  }
  
  private startSplashSequence() {
    // Show title after last grape appears (1.8s - right after grape-9 at 1.3s + animation time)
    setTimeout(() => {
      this.showTitle = true;
    }, 1800);
    
    // Show subtitle (2.4s)
    setTimeout(() => {
      this.showSubtitle = true;
    }, 2400);
    
    // Show loading dots (3.0s)
    setTimeout(() => {
      this.showLoading = true;
    }, 3000);
    
    // Check if data loading is complete before auto-closing
    // If data is still loading, wait for it to complete
    // Otherwise, close after normal timing (6s)
    setTimeout(() => {
      if (!this.isLoadingData && !this.wasSkipped) {
        this.isClosing = true;
        setTimeout(() => {
          this.splashComplete.emit();
        }, 500);
      }
      // If still loading, parent component will handle closing when data is ready
    }, 6000);
    
    // Force close after maximum 6 seconds regardless of loading state
    setTimeout(() => {
      if (!this.isClosing) {
        this.isClosing = true;
        setTimeout(() => {
          this.splashComplete.emit();
        }, 500);
      }
    }, 6000);
  }
  
  // Method to skip splash screen on tap/click
  skipSplash() {
    // Always close immediately when clicked, regardless of loading state
    this.isClosing = true;
    setTimeout(() => {
      this.splashComplete.emit();
    }, 300); // Shorter delay for immediate response
  }
  
  // Called when data loading is complete from parent component
  completeAfterDataLoading() {
    if (this.wasSkipped || !this.isLoadingData) {
      this.isClosing = true;
      setTimeout(() => {
        this.splashComplete.emit();
      }, 500);
    }
  }
}
